__turbopack_context__.v({
  "acceptance": "TermsOfUseAcceptance-module__FCb-4W__acceptance",
  "greet": "TermsOfUseAcceptance-module__FCb-4W__greet",
  "link": "TermsOfUseAcceptance-module__FCb-4W__link",
  "message": "TermsOfUseAcceptance-module__FCb-4W__message",
  "termsOfUse": "TermsOfUseAcceptance-module__FCb-4W__termsOfUse",
});
